var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoveParticipant = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 13.8012C11.6845 13.8012 12.3018 13.633 12.8518 13.2967C13.4018 12.9603 13.8356 12.5174 14.1534 11.9679C13.7256 11.6134 13.2429 11.3414 12.7051 11.1517C12.1673 10.962 11.599 10.8674 11.0001 10.8679C10.4012 10.8679 9.83287 10.9627 9.29509 11.1524C8.75731 11.3421 8.27453 11.6139 7.84676 11.9679C8.16453 12.5179 8.59842 12.961 9.14842 13.2974C9.69842 13.6338 10.3156 13.8017 11.0001 13.8012ZM11.0001 10.1345C11.4034 10.1345 11.7488 9.9908 12.0363 9.70333C12.3238 9.41587 12.467 9.07071 12.466 8.66787C12.466 8.26453 12.3223 7.91913 12.0348 7.63167C11.7474 7.3442 11.4024 7.20071 11.0001 7.2012C10.5968 7.2012 10.2514 7.34493 9.96389 7.6324C9.67642 7.91987 9.53318 8.26502 9.53416 8.66787C9.53416 9.0712 9.67789 9.4166 9.96536 9.70407C10.2528 9.99153 10.5977 10.135 11.0001 10.1345ZM11.0001 18.9345C9.03231 17.2601 7.56271 15.7049 6.59129 14.2691C5.61987 12.8332 5.13391 11.5039 5.13342 10.2812C5.13342 8.44787 5.72327 6.98731 6.90296 5.89953C8.08265 4.81176 9.44811 4.26787 10.9994 4.26787C12.5516 4.26787 13.9175 4.81176 15.0972 5.89953C16.2769 6.98731 16.8665 8.44787 16.866 10.2812C16.866 11.5034 16.3801 12.8327 15.4082 14.2691C14.4362 15.7054 12.9669 17.2606 11.0001 18.9345Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoveParticipant);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moveParticipant.44e25cc983a21395b5b30fdb15534136.svg";